export const copyBlobToClipboard = (blob: Blob) => {
  navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]).catch((_error) => {
    // Likely error is if someone tabs away from REx after clicking copy and getting
    // "Failed to execute 'write' on 'Clipboard': Document is not focused."
  })
}
